export default "__VITE_ASSET__dAe4IPni__"